import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// === BOOTSTRAP DO MANIFEST (ANTES DO REACT SUBIR) ===
(() => {
  const path = window.location.pathname;              // ex: "/bit0540/alguma-rota"
  const tenant = path.split('/').filter(Boolean)[0];  // "bit0540" ou undefined

  const manifestEl = document.getElementById('pwa-manifest');

  // Se você adicionou <link id="pwa-manifest" rel="manifest" ...> no public/index.html
  if (manifestEl) {
    if (tenant) {
      manifestEl.setAttribute('href', `/${tenant}/manifest.webmanifest`);
    } else {
      manifestEl.setAttribute('href', `/manifest.webmanifest`);
    }
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();
